import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEY } from "../../../constants/localStorageKeys";
import { UserCurrent,Party } from "../../../types/userCurrent";
import { AppThunk } from "../../store";

export type AuthState = {
    isLoggedIn: boolean;
    currentUser: UserCurrent | null;
    token: string;
    currentParty: Party | null;
};

const initialState: AuthState = {
    isLoggedIn: false,
    currentUser: null,
    token: "",
    currentParty: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setLoggedIn(state) {
            state.isLoggedIn = true;
        },
        setCurrentUser(state, action: PayloadAction<UserCurrent>) {
            state.currentUser = action.payload;
        },
        setCurrentParty(state, action: PayloadAction<Party>) {
            state.currentParty = action.payload;
        },
        setToken(state, action: PayloadAction<string>) {
            state.token = action.payload;
        },
        resetAuth() {
            return initialState;
        },
    },
});

const { setLoggedIn, setCurrentUser, setToken, resetAuth, setCurrentParty } = authSlice.actions;

export const clearAuth = (): AppThunk => (dispatch) => {
    localStorage.removeItem(LOCAL_STORAGE_KEY.CSRF_TOKEN);
    dispatch(resetAuth());
    return;
};

export { setCurrentUser, setLoggedIn, setToken, setCurrentParty };

const authReducer = authSlice.reducer;
export default authReducer;
